enum ThemeTonalRange {
  BRIGHT = 'bright',
  ULTRA_LIGHT = 'ultra-light',
  VERY_DARK = 'very-dark',
  VERY_LIGHT = 'very-light',
}

export default ThemeTonalRange;
